/**
 * dcent-pdp-affiliate-header.js — 인플루언서 밴드의 **쿼리 모드** 채우기.
 *
 * 왜 JS 인가: 글로벌은 인플루언서 전원이 상품 하나를 공유해 누구인지가 URL 쿼리 bg_ref 에만 있다.
 * Shopify Liquid 은 쿼리 문자열을 못 읽으므로(request 객체에 없다) 서버에서는 고를 수 없다.
 * 캐시 실측으로도 확인됐다 — 같은 URL 의 서버 응답이 bg_ref 별로 갈리지 않았다.
 * 한국은 상품 handle 접미어로 서버에서 끝나므로 그 경우 섹션이 이 파일을 아예 내보내지 않는다.
 *
 * 가드는 라이브와 같다: 경로에 path_guard 포함 + bg_ref 존재 + 명단에 있는 코드.
 * 셋 중 하나라도 어긋나면 밴드는 hidden 인 채로 둔다(잘못된 인플루언서가 노출되는 쪽이 더 나쁘다).
 *
 * 값은 textContent 로만 넣는다 — 인용문에 든 따옴표·꺾쇠가 마크업으로 해석되지 않게 한다.
 * 양 샵 byte-identical.
 */
(function () {
  "use strict";

  var ROOT_SELECTOR =
    '[data-section-type="dcent-pdp-affiliate-header"][data-affiliate-mode="query"]';
  var READY_ATTR = "data-affiliate-ready";

  /** 섹션이 내보낸 명단 JSON. 없거나 깨졌으면 빈 배열 — 밴드는 숨은 채로 남는다. */
  function readList(root) {
    var node = root.querySelector(
      'script[type="application/json"][data-dcent-aff-map]',
    );
    if (!node) return [];
    try {
      var parsed = JSON.parse(node.textContent || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      return [];
    }
  }

  function setText(root, selector, value) {
    var el = root.querySelector(selector);
    if (!el) return;
    el.textContent = value == null ? "" : String(value);
  }

  function fill(root) {
    if (root.getAttribute(READY_ATTR) === "1") return;

    var url;
    try {
      url = new URL(window.location.href);
    } catch (err) {
      return;
    }

    var guard = (root.getAttribute("data-path-guard") || "").trim();
    if (guard && url.pathname.indexOf(guard) === -1) return;

    var code = url.searchParams.get("bg_ref");
    if (!code) return;

    var list = readList(root);
    var entry = null;
    for (var i = 0; i < list.length; i += 1) {
      if (list[i] && list[i].code === code) {
        entry = list[i];
        break;
      }
    }
    if (!entry) return;

    var title = entry.title == null ? "" : String(entry.title);
    setText(root, ".dcent-pah__title", title);
    setText(root, ".dcent-pah__text1", entry.text1);
    setText(root, ".dcent-pah__text2", entry.text2);
    setText(root, ".dcent-pah__text3", entry.text3);

    var img = root.querySelector(".dcent-pah__logo-img");
    if (img) {
      if (entry.logo) {
        img.setAttribute("src", String(entry.logo));
        img.setAttribute("alt", title);
        img.removeAttribute("hidden");
      } else {
        // 로고가 없으면 컬럼째 접는다. img 만 지우면 컬럼에 공백 텍스트 노드가 남아
        // :empty 가 안 걸리고 PC 에서 빈 40% 가 그대로 자리를 차지한다.
        var col = img.closest(".dcent-pah__logo");
        if (col) col.setAttribute("hidden", "");
      }
    }

    root.setAttribute(READY_ATTR, "1");
    root.removeAttribute("hidden");
  }

  function run(scope) {
    var base = scope && scope.querySelectorAll ? scope : document;
    var nodes = base.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < nodes.length; i += 1) fill(nodes[i]);
    // 테마 에디터는 갱신된 섹션 자체를 target 으로 준다 — 그 자신이 루트일 수 있다.
    if (base.matches && base.matches(ROOT_SELECTOR)) fill(base);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      run(document);
    });
  } else {
    run(document);
  }

  document.addEventListener("shopify:section:load", function (evt) {
    run(evt.target || document);
  });
})();
